import {
    IPlacementRating,
    UsePlacementHandlersProps,
} from "../types/placement";

import { alertActions } from "../../../../../features/alert/alertSlice";
import { selectSetting } from "../../../../../features/global/globalSlice";
import {
    useAppDispatch,
    useAppSelector,
} from "../../../../../hooks/reduxHooks";
import { useAuthenticatedUser } from "../../../../../hooks/useAuthenticatedUser";
import { updatePlacementRatings } from "../../../../../lib/api";

const usePlacementHandlers = ({
    setRatings,
    setUpdateStatus,
}: UsePlacementHandlersProps) => {
    const dispatch = useAppDispatch();
    const user = useAuthenticatedUser();
    const year = useAppSelector(state =>
        selectSetting(state, "majorybl_current_league_year"),
    );

    const handleStarClick = async (teamId: number, idx: number) => {
        setUpdateStatus("pending");
        try {
            await updatePlacementRatings(teamId, idx, user.id);
            setUpdateStatus("success");
            setRatings(prev => {
                const updatedState = prev.filter(r => {
                    return (
                        r.team !== teamId &&
                        r.ratedBy === user!.id &&
                        r.year === parseInt(year?.setting)
                    );
                });

                return [
                    ...updatedState,
                    {
                        team: teamId,
                        year: parseInt(year?.setting),
                        rating: idx as IPlacementRating["rating"],
                        ratedBy: user!.id,
                    },
                ];
            });
            setTimeout(() => {
                setUpdateStatus(undefined);
            }, 3000);
        } catch (error: any) {
            setUpdateStatus("failed");
            dispatch(
                alertActions.error({
                    title: "There was a problem updating the placement ratings",
                    text: "If the problem persists, please contact an admin",
                    dismissible: true,
                }),
            );
        }
    };

    return { handleStarClick };
};

export default usePlacementHandlers;
